import { configureStore } from "@reduxjs/toolkit";
import footerReducer from "./footerSlice";
import headerReducer from "./headerSlice";
import loaderReducer from "./loaderSlice";
import sliderReducer from "./sliderSlice";

export const store = configureStore({
  reducer: {
    footer: footerReducer,
    header: headerReducer,
    loader: loaderReducer,
    slider: sliderReducer,
  },
});

// ✅ Correctly export these
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
